<template>
  <div>
    <!--  Tabla  -->
    <div class="table-responsive" v-if="data.length > 0">
      <table class="table table-bordered table-sm">
        <thead class="table-secondary">
          <tr>
            <th
              v-for="col in columns"
              :key="col.field"
            >
              {{ col.label }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="row in datosPaginados" :key="row[idField]">
            <td v-for="col in columns" :key="col.field">
              <slot :name="`cell-${col.field}`" :row="row">
                {{ col.format ? col.format(row[col.field], row) : row[col.field] }}
              </slot>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-else class="alert alert-info text-center mt-3">
      {{ mensajeVacio }}
    </div>

  </div>
</template>

<script>
export default {
  name: 'DataTableSimple',

  props: {
    data:          { type: Array,  default: () => [] },
    columns:       { type: Array,  required: true },
    idField:       { type: String, default: 'id' },
    mensajeVacio:  { type: String, default: 'No hay registros disponibles.' },
    porPagina:     { type: Number, default: 10 },
  },

  data() {
    return {
      campoOrden:         '',
      ascendente:         true,
      paginaActual:       1,
      elementosPorPagina: this.porPagina,
      datosPaginados:     [],
    }
  },

  computed: {
    dataOrdenada() {
      if (!this.campoOrden) return [...this.data]
      return [...this.data].sort((a, b) => {
        const va  = a[this.campoOrden] ?? ''
        const vb  = b[this.campoOrden] ?? ''
        const cmp = String(va).localeCompare(String(vb), 'es')
        return this.ascendente ? cmp : -cmp
      })
    },
    totalPaginas() {
      return Math.max(1, Math.ceil(this.dataOrdenada.length / this.elementosPorPagina))
    },
    paginasVisibles() {
      const total  = this.totalPaginas
      const actual = this.paginaActual
      const delta  = 2
      const rango  = []
      for (let i = Math.max(2, actual - delta); i <= Math.min(total - 1, actual + delta); i++) {
        rango.push(i)
      }
      if (rango.length && rango[0] > 2)                        rango.unshift('...')
      if (rango.length && rango[rango.length - 1] < total - 1) rango.push('...')
      const paginas = [1]
      rango.forEach(p => paginas.push(p))
      if (total > 1) paginas.push(total)
      return paginas
    },
  },

  watch: {
    data: {
      immediate: true,
      handler() { this.aplicarPaginacion(1) },
    },
  },

  methods: {
    iconOrden(campo) {
      if (this.campoOrden !== campo) return '⇅'
      return this.ascendente ? '↑' : '↓'
    },
    aplicarPaginacion(pagina) {
      if (pagina < 1 || pagina > this.totalPaginas) return
      this.paginaActual   = pagina
      const ini           = (pagina - 1) * this.elementosPorPagina
      this.datosPaginados = this.dataOrdenada.slice(ini, ini + this.elementosPorPagina)
    },
  },
}
</script>